import { Modal, Box, Typography } from "@mui/material";
import { useState } from "react";
import React from "react";
const modalStyle = {
  position: "absolute",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  width: "90%",
  maxWidth: 550,
  maxHeight: "80vh",
  overflow: "auto",
  bgcolor: "background.paper",
  border: "none",
  borderRadius: "4px",
  boxShadow: 24,
  p: 3
};

const modalHeaderStyle = {
  p: 2,
  paddingBottom: 1,
  fontSize: "1.5rem",
  borderBottom: "1px solid #ddd",
  marginBottom: 1
};

function DetailsButtonCell(props) {
  const [open, setOpen] = useState(false);

  const handleOpen = () => setOpen(true);
  const handleClose = () => setOpen(false);

  return (
    <div>
      <button onClick={handleOpen}>More</button>
      <Modal
        open={open}
        onClose={handleClose}
        aria-labelledby="modal-title"
        aria-describedby="modal-description"
      >
        <Box sx={modalStyle}>
          <Box sx={modalHeaderStyle}>
            <Typography id="modal-title" variant="h5" component="div">
              Answers
            </Typography>
          </Box>

          <Box
            sx={{ overflow: "auto", maxHeight: "70vh", marginTop: 2 }} // Add a margin-top
            id="modal-description"
          >
            {props.row.details.map((q, index) => (
              <Box key={index} mb={2}>
                <Typography variant="body2" gutterBottom>
                  {index + 1}. {q.question}
                </Typography>
                <Typography variant="caption">Answer: {q.answer}</Typography>
              </Box>
            ))}
          </Box>
        </Box>
      </Modal>
    </div>
  );
}

export default DetailsButtonCell;
